import { render, staticRenderFns } from "./BasicCollectiveChatRoomWidget.vue?vue&type=template&id=099c9b54&scoped=true"
import script from "./BasicCollectiveChatRoomWidget.vue?vue&type=script&lang=js"
export * from "./BasicCollectiveChatRoomWidget.vue?vue&type=script&lang=js"
import style0 from "./BasicCollectiveChatRoomWidget.vue?vue&type=style&index=0&id=099c9b54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099c9b54",
  null
  
)

export default component.exports